var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGbFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2018_6300)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32,
    rx: 4,
    fill: "#1CAF0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000281094H48V32.0006H0V0.000281094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 5.46528e-07H21V12.9999H0V18.9999H21V31.9999H27V18.9999H48V12.9999H27V5.46528e-07Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9173 21.5651L48 27.7222V21.5651H36.9173ZM29.2174 21.5651L48 31.9999V29.0492L34.5288 21.5651H29.2174ZM42.9969 31.9999L29.2174 24.3439V31.9999H42.9969Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2174 21.5651L48 31.9999V29.0492L34.5288 21.5651H29.2174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2174 21.5651L48 31.9999V29.0492L34.5288 21.5651H29.2174Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46947 21.5649L0 26.2702V21.5649H8.46947ZM18.7826 22.8919V31.9998H2.38978L18.7826 22.8919Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4712 21.5651L0 29.0492V31.9999L18.7826 21.5651H13.4712Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0827 10.4348L0 4.27762V10.4348H11.0827ZM18.7826 10.4348L0 5.29405e-07V2.95069L13.4712 10.4348H18.7826ZM5.00306 5.29405e-07L18.7826 7.656V5.29405e-07H5.00306Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7826 10.4348L0 5.29405e-07V2.95069L13.4712 10.4348H18.7826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7826 10.4348L0 5.29405e-07V2.95069L13.4712 10.4348H18.7826Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5305 10.4349L48 5.72963V10.4349H39.5305ZM29.2174 9.108V9.368e-05H45.6102L29.2174 9.108Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5288 10.4348L48 2.95069V0L29.2174 10.4348H34.5288Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2018_6300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbFlag);
export default __webpack_public_path__ + "static/media/gb_flag.11ee057cef489780cc30a4b44694c259.svg";
export { ForwardRef as ReactComponent };